import settingsGear from '../assets/brand/settings-gear.png'

export function SettingsGearIcon() {
  return <img className="settings-gear-icon" src={settingsGear} alt="" aria-hidden="true" />
}
